import _classCallCheck from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Dev\\VSS\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import Effect from "./Effect";
import Filter from "./Filter";

var Delay =
/*#__PURE__*/
function (_Effect) {
  _inherits(Delay, _Effect);

  function Delay(context) {
    var _this;

    _classCallCheck(this, Delay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Delay).call(this, context));
    _this.name = "delay";
    return _this;
  }

  _createClass(Delay, [{
    key: "setup",
    value: function setup() {
      this.effect = this.context.createDelay();
      this.effect.delayTime.value = 0.5;
      this.dry = this.context.createGain();
      this.wet = this.context.createGain();
      this.feedback = this.context.createGain();
      this.feedback.gain.value = 0.75;
      this.filter = new Filter(this.context, "bandpass", 1000, 0.3);
    }
  }, {
    key: "wireUp",
    value: function wireUp() {
      this.input.connect(this.dry);
      this.dry.connect(this.output);
      this.wet.connect(this.output);
      this.input.connect(this.effect);
      this.effect.connect(this.wet);
      this.effect.connect(this.filter.input);
      this.filter.connect(this.feedback);
      this.feedback.connect(this.effect);
    }
  }, {
    key: "feedbackAmount",
    set: function set(value) {
      var normalizedValue = value;

      if (normalizedValue > 0.98) {
        normalizedValue = 0.98;
      }

      this.feedback.gain.value = normalizedValue;
    },
    get: function get() {
      return this.feedback.gain.value;
    }
  }, {
    key: "filterFrequency",
    set: function set(value) {
      this.filter.effect.frequency.value = value;
    },
    get: function get() {
      return this.filter.effect.frequency.value;
    }
  }, {
    key: "filterQ",
    set: function set(value) {
      this.filter.effect.Q.value = value;
    },
    get: function get() {
      return this.filter.effect.Q.value;
    }
  }]);

  return Delay;
}(Effect);

export { Delay as default };